// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table.table tbody td[data-v-388c688c] {\n  border: 0;\n}\n.cursor-pointer[data-v-388c688c] {\n  cursor: pointer;\n}\n.cursor-default[data-v-388c688c] {\n  cursor: default;\n}\n.tag[data-v-388c688c] {\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
